// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel';

export type MetricValueDataTypeEnum = 'INT' | 'STRING' | 'DATE';

export type PjpMetricResponseModelType = {
    metricsData: Array<PjpMetricsItemModelType>
};

export type PjpMetricsItemModelType = {
    currentPlan: PjpMetricDataModelType,
    existingPlan: ?PjpMetricDataModelType
};

export type PjpMetricDataModelType = {
    metric: string,
    metricDataItems: ?Array<PjpMetricDataItemModelType>,
    metricTotal: PjpMetricTotalModelType,
    previousMetricTotal: ?PjpMetricTotalModelType
};

export type PjpMetricDataItemModelType = {
    metricDataRow: {
        [key: string]: PjpMetricValueModelType
    }
};

export type PjpMetricTotalModelType = {
    metricDataRow: {
        [key: string]: PjpMetricValueModelType
    }
};

export type PjpMetricValueModelType = {
    value: string | number,
    valueDataType: PjpMetricValueDataTypeEnum
};

export type PjpMetricValueDataTypeEnum = 'INT' | 'STRING' | 'DATE' | 'OBJECT';

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class PjpMetricResponse extends ImmutableModel {
    static fromJS(json: PjpMetricResponseModelType): PjpMetricResponse {
        const state: Object = Object.assign({}, json);
        state.metricsData = Immutable.List(state.metricsData).map(item =>
            PjpMetricsItem.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): PjpMetricResponseModelType {
        return {
            metricsData: this.metricsData.toArray().map(item => item.toJS())
        };
    }

    get metricsData(): Immutable.List<PjpMetricsItem> {
        return this._state.get('metricsData');
    }

    setMetricsData(metricsData: Immutable.List<PjpMetricsItem>): this {
        return this.clone(this._state.set('metricsData', metricsData));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class PjpMetricsItem extends ImmutableModel {
    static fromJS(json: PjpMetricsItemModelType): PjpMetricsItem {
        const state: Object = Object.assign({}, json);
        state.currentPlan = PjpMetricData.fromJS(state.currentPlan);
        state.existingPlan = state.existingPlan
            ? PjpMetricData.fromJS(state.existingPlan)
            : state.existingPlan;
        return new this(Immutable.Map(state));
    }

    toJS(): PjpMetricsItemModelType {
        return {
            currentPlan: this.currentPlan.toJS(),
            existingPlan: this.existingPlan
                ? this.existingPlan.toJS()
                : this.existingPlan
        };
    }

    get currentPlan(): PjpMetricData {
        return this._state.get('currentPlan');
    }

    setCurrentPlan(currentPlan: PjpMetricData): this {
        return this.clone(this._state.set('currentPlan', currentPlan));
    }

    get existingPlan(): ?PjpMetricData {
        return this._state.get('existingPlan');
    }

    setExistingPlan(existingPlan: ?PjpMetricData): this {
        return this.clone(this._state.set('existingPlan', existingPlan));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class PjpMetricData extends ImmutableModel {
    static fromJS(json: PjpMetricDataModelType): PjpMetricData {
        const state: Object = Object.assign({}, json);
        state.metricDataItems = state.metricDataItems
            ? Immutable.List(state.metricDataItems).map(item =>
                  PjpMetricDataItem.fromJS(item)
              )
            : state.metricDataItems;
        state.metricTotal = PjpMetricTotal.fromJS(state.metricTotal);
        state.previousMetricTotal = state.previousMetricTotal
            ? PjpMetricTotal.fromJS(state.previousMetricTotal)
            : state.previousMetricTotal;
        return new this(Immutable.Map(state));
    }

    toJS(): PjpMetricDataModelType {
        return {
            metric: this.metric,
            metricDataItems: this.metricDataItems
                ? this.metricDataItems.toArray().map(item => item.toJS())
                : this.metricDataItems,
            metricTotal: this.metricTotal.toJS(),
            previousMetricTotal: this.previousMetricTotal
                ? this.previousMetricTotal.toJS()
                : this.previousMetricTotal
        };
    }

    get metric(): string {
        return this._state.get('metric');
    }

    setMetric(metric: string): this {
        return this.clone(this._state.set('metric', metric));
    }

    get metricDataItems(): ?Immutable.List<PjpMetricDataItem> {
        return this._state.get('metricDataItems');
    }

    setMetricDataItems(
        metricDataItems: ?Immutable.List<PjpMetricDataItem>
    ): this {
        return this.clone(this._state.set('metricDataItems', metricDataItems));
    }

    get metricTotal(): PjpMetricTotal {
        return this._state.get('metricTotal');
    }

    setMetricTotal(metricTotal: PjpMetricTotal): this {
        return this.clone(this._state.set('metricTotal', metricTotal));
    }

    get previousMetricTotal(): ?PjpMetricTotal {
        return this._state.get('previousMetricTotal');
    }

    setPreviousMetricTotal(previousMetricTotal: ?PjpMetricTotal): this {
        return this.clone(
            this._state.set('previousMetricTotal', previousMetricTotal)
        );
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class PjpMetricDataItem extends ImmutableModel {
    static fromJS(json: PjpMetricDataItemModelType): PjpMetricDataItem {
        const state: Object = Object.assign({}, json);
        state.metricDataRow = Immutable.Map(state.metricDataRow).map(item =>
            PjpMetricValue.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): PjpMetricDataItemModelType {
        return {
            metricDataRow: this.metricDataRow
                .map(item => item.toJS())
                .toObject()
        };
    }

    get metricDataRow(): Immutable.Map<string, PjpMetricValue> {
        return this._state.get('metricDataRow');
    }

    setMetricDataRow(
        metricDataRow: Immutable.Map<string, PjpMetricValue>
    ): this {
        return this.clone(this._state.set('metricDataRow', metricDataRow));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class PjpMetricTotal extends ImmutableModel {
    static fromJS(json: PjpMetricTotalModelType): PjpMetricTotal {
        const state: Object = Object.assign({}, json);
        state.metricDataRow = Immutable.Map(state.metricDataRow).map(item =>
            PjpMetricValue.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): PjpMetricTotalModelType {
        return {
            metricDataRow: this.metricDataRow
                .map(item => item.toJS())
                .toObject()
        };
    }

    get metricDataRow(): Immutable.Map<string, PjpMetricValue> {
        return this._state.get('metricDataRow');
    }

    setMetricDataRow(
        metricDataRow: Immutable.Map<string, PjpMetricValue>
    ): this {
        return this.clone(this._state.set('metricDataRow', metricDataRow));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class PjpMetricValue extends ImmutableModel {
    static fromJS(json: PjpMetricValueModelType): PjpMetricValue {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): PjpMetricValueModelType {
        return {
            value: this.value,
            valueDataType: this.valueDataType
        };
    }

    get value(): string | number {
        return this._state.get('value');
    }

    setValue(value: string | number): this {
        return this.clone(this._state.set('value', value));
    }

    get valueDataType(): PjpMetricValueDataTypeEnum {
        return this._state.get('valueDataType');
    }

    setValueDataType(valueDataType: PjpMetricValueDataTypeEnum): this {
        return this.clone(this._state.set('valueDataType', valueDataType));
    }
}
